import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-settings-dropdown-icon',
    templateUrl: './settings-dropdown-icon.component.html',
    styleUrls: ['./settings-dropdown-icon.component.scss'],
    standalone: false
})
export class SettingsDropdownIconComponent {

  imgDropdown = '/assets/images/more_options_icon.svg';
  imgOverDropdown = '/assets/images/more_options_icon_white.svg';
  imgDropdownGray = '/assets/images/more_options_icon_gray.svg';

  @Input() defaultGrayColor = false;
  @Input() hideBorder = false;
  @Input() isDisabled = false;

  changeIconDropdown(icon: HTMLImageElement, parent: HTMLDivElement, over: boolean, isDisabled: boolean) {
    if(isDisabled) {
      return;
    }
    icon.src = (over) ? this.imgOverDropdown : this.getDefaultIcon();
    parent.classList.toggle('bg-brand');
  }

  private getDefaultIcon(): string {
    return this.defaultGrayColor ? this.imgDropdownGray : this.imgDropdown;
  }

}
